import { render, staticRenderFns } from "./DetailEdit.vue?vue&type=template&id=42ed8840&scoped=true"
import script from "./DetailEdit.vue?vue&type=script&lang=js"
export * from "./DetailEdit.vue?vue&type=script&lang=js"
import style0 from "./DetailEdit.vue?vue&type=style&index=0&id=42ed8840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ed8840",
  null
  
)

export default component.exports